import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './section-title.scss.js';
import { Alignment } from './types.js';

const LitElementWithUtils = BaseWithUtils(s);
class SectionTitle extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.popupHeading = false;
        this.divider = false;
        this.rtl = false;
        this.titleAlignment = 'left';
        this.titleSize = 'small';
        this.titleColor = 'black';
        this.fullWidth = false;
    }
    isSlotElementEmpty(name) {
        const element = this.shadowRoot.querySelector(`[name="${name}"]`);
        return element.assignedNodes().length === 0;
    }
    isElementEmpty(attribute) {
        const element = this.shadowRoot.querySelector(attribute);
        return element.childNodes.length === 0;
    }
    getElement(attribute) {
        return this.shadowRoot.querySelector(attribute);
    }
    renderMobileImage() {
        const imgSlot = this.renderRoot.querySelector('slot[name="image"]');
        const image = imgSlot.assignedNodes()[0];
        if (!image)
            return;
        const mobileImgContainer = this.renderRoot.querySelector('.image-mobile');
        mobileImgContainer.appendChild(image.cloneNode());
    }
    firstUpdated() {
        setTimeout(() => {
            var _a, _b;
            const headlineWrapper = (_a = this.querySelector('[slot="headline"]')) === null || _a === void 0 ? void 0 : _a.querySelector('.headline-wrapper');
            const bodyText = this.querySelector('[slot="body-text"]');
            if (headlineWrapper)
                headlineWrapper.style.maxWidth = `${bodyText === null || bodyText === void 0 ? void 0 : bodyText.clientWidth}px`;
            if (this.isSlotElementEmpty('primary-cta') &&
                this.isSlotElementEmpty('secondary-cta'))
                this.getElement('.cta-container').style.display = 'none';
            if (this.isSlotElementEmpty('primary-cta') &&
                this.isElementEmpty('.body-text') &&
                this.getElement('.headline-page'))
                this.getElement('.headline-page').style.paddingBottom = '0';
            const parent = this.parentElement;
            if ((parent === null || parent === void 0 ? void 0 : parent.getAttribute('slot')) &&
                (parent === null || parent === void 0 ? void 0 : parent.getAttribute('slot')) === 'big-card')
                (_b = this.querySelector('.headline-big')) === null || _b === void 0 ? void 0 : _b.classList.add('hide-border');
            this.renderMobileImage();
            if (parent.classList.contains('search-field-results-page__section-title'))
                this.fullWidth = true;
        }, 0);
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        return $ `<div class="section-title ${this.rtl || isRTL() ? 'rtl' : ''} ${(_a = this.alignment) !== null && _a !== void 0 ? _a : ''} ${(_b = this.locatedIn) !== null && _b !== void 0 ? _b : ''} ${this.popupHeading ? 'popup-heading' : ''} ${(_c = this.utilityClasses) !== null && _c !== void 0 ? _c : ''} ${this.divider ? 'divider' : ''} ${this.fullWidth ? 'full-width' : ''}" ${(_d = this.titleColor) !== null && _d !== void 0 ? _d : 'black'} ${(_e = this.titleSize) !== null && _e !== void 0 ? _e : 'small'} ${(_f = this.titleAlignment) !== null && _f !== void 0 ? _f : 'left'}><div class="inner"><slot name="headline"></slot><div class="image-mobile"></div><slot name="body-text" class="body-text"></slot><div class="cta-container"><slot name="primary-cta"></slot><slot name="secondary-cta"></slot></div></div><div class="image"><slot name="image"></slot></div></div>`;
    }
}
SectionTitle.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e()
], SectionTitle.prototype, "headlineType", void 0);
__decorate([
    e({ type: String })
], SectionTitle.prototype, "locatedIn", void 0);
__decorate([
    e({ type: Boolean })
], SectionTitle.prototype, "popupHeading", void 0);
__decorate([
    e({ type: Alignment })
], SectionTitle.prototype, "alignment", void 0);
__decorate([
    e({ type: Boolean })
], SectionTitle.prototype, "divider", void 0);
__decorate([
    e({ type: Boolean })
], SectionTitle.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], SectionTitle.prototype, "titleAlignment", void 0);
__decorate([
    e({ type: String })
], SectionTitle.prototype, "titleSize", void 0);
__decorate([
    e({ type: String })
], SectionTitle.prototype, "titleColor", void 0);
__decorate([
    t()
], SectionTitle.prototype, "fullWidth", void 0);
customElements.define('section-title', SectionTitle);

export { SectionTitle };
